<p-tag
  [value]="translationKey() | transloco"
  [severity]="severity()"
  [style]="{minWidth: '100px'}"
/>
